<template>
  <pl-dialog :title="modalTitle" size="md" :disableOutsideClick="true" @close="closeCurrentModal()">
    <header class="px-6">
      <div class="flex space-x-3 items-center mb-4 mt-3">
        <span>
          After adding a new feedback template you can use on all students or import later to another course, will not be change the old templates.  
        </span>
      </div>
    </header>
    <body class="w-full flex-grow overflow-y-auto h-80 mb-4 center items-center px-6 relative">
      <textarea
        v-model="template"
        ref="template-area"
        class="bg-gray-100 rounded outline-none w-full px-4 py-3 h-full border border-solid border-gray-200 focus:border-gray-300"
        placeholder="Write a new feedback template..."
      />
    </body>
    <footer class="px-6 mb-5">
      <div class="flex justify-between items-center">
        <button @click="closeCurrentModal()" class="bg-gray-100 border hover:border-gray-300 border-solid border-gray-200 text-sm text-gray-600 rounded px-6 py-2">
          Cancel
        </button>
        <button @click="editingFeedback === false ? handleCreateFeedback() : handleEditFeedback() " :class="isTemplateFilled">
          <div class="flex justify-center space-x-2">
            <span v-if="editingFeedback === false">{{ isCreating === true ? 'Creating' : 'Create' }}</span>
             <span v-if="editingFeedback === true">{{ isEditing === true ? 'Saving' : 'Save' }}</span>
            <div class="loader" v-show="isCreating || isEditing"></div>
          </div>
        </button>
      </div>
    </footer>
  </pl-dialog>    
</template>
<script>
import Vue from 'vue';
export default Vue.extend({
  props: {
    typeRoundtable: { type: String, default: 'online' },
    editingFeedback: { type: Boolean, default: false },
    feedbackID: { type: String, default: '' },
    feedbackContent: { type: String, default: '' },
  },
  data: () => ({
    isCreating: false,
    isEditing: false,
    template: '',
    course_id: '',
  }),
  computed: {
    isTemplateFilled: function () {
      const default_class = 'text-sm text-white rounded px-6 py-2';
      if (this.template.length === 0 || this.template === this.feedbackContent) {
        return default_class+ ' bg-primary bg-opacity-50';
      }
      return default_class + ' bg-primary';
    },
    modalTitle: function () {
      if (this.editingFeedback === false ) {
        return 'New Feedback Template';
      }
      return 'Edit Feedback Template';
    }
  },
  methods: {
    closeCurrentModal: function () {
      return this.$emit('close');
    },
    handleCreateFeedback: async function () {
      this.isCreating = true;
      const feedback = { course_id: this.course_id, text: this.template, roundtable_type: this.typeRoundtable };
      await this.$store.dispatch('saveFeedback', feedback);
      this.isCreating = false; 
      return this.closeCurrentModal();
    },
    handleEditFeedback: async function () {
      this.isEditing = true;
      const feedback = { course_id: this.course_id, feedback_id: this.feedbackID, text: this.template, roundtable_type: this.typeRoundtable };
      await this.$store.dispatch('updateFeedback', feedback);
      this.isEditing = false;
      return this.closeCurrentModal();
    },
  },
  mounted: async function () {
    const { courseID } = this.$route.params;
    this.$refs['template-area'].focus();
    this.course_id = courseID;
    if (this.editingFeedback === true ) {
      this.template = this.feedbackContent;
    }
  } 
});
</script>
<style scoped>
  .loader, .loader:after {
    border-radius: 50%;
    width: 20px;
    height: 20px;
    margin-left: 12px;
    margin-top: 1px;
  }
  .loader {
    border-top: 3px solid rgba(255, 255, 255, 0.2);
    border-right: 3px solid rgba(255, 255, 255, 0.2);
    border-bottom: 3px solid rgba(255, 255, 255, 0.2);
    border-left: 3px solid #ffffff;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-animation: load8 1.1s infinite linear;
    animation: load8 1.1s infinite linear;
  }
  @-webkit-keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
</style>


// WEBPACK FOOTER //
// NewFeedbackModal.vue?773fa790